import React from "react";
import PropTypes from "prop-types";
import { asNumberString } from "../../utils/formatters";
import AnimatedNumber from "react-animated-number";
function Badge(props) {
  props = {
    value: 23,
    size: 55,
    color: "#4a9bff",
    background: "red",
    width: "18px",
    height: "18px",
    ...props
  };

  return (
    <AnimatedNumber
      data-testid="badge"
      component="h5"
      value={0 || props.value}
      style={{
        margin: "-3px 0 0 0",
        padding: 0,
        fontWeight: "400",
        transition: "0.8s ease-out",
        fontSize: props.size,
        color: props.color,
        background: props.background,
        width: props.size + 8,
        height: props.size + 8,
        borderRadius: "50%",
        lineHeight: props.size + 8 + "px",
        textAlign: "center"
      }}
      className="badge"
      duration={0}
      stepPrecision={0}
      formatValue={(n) => asNumberString(n, props.value)}
    />
  );
}

Badge.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.number,
  color: PropTypes.string,
  background: PropTypes.string
};

export default Badge;
